import STORE from 'config/store.singleton';

const dispatch = STORE.dispatch.bind(STORE);

export default dispatch;
